var core = require('./_core');
module.exports = function (CONSTRUCTOR) {
  var C = core[CONSTRUCTOR];
  return (C.virtual || C.prototype);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_entry-virtual.js
// module id = 1502
// module chunks = 1